<template>
  <section v-if="$role.restricAccess($route.name, 'view')">
    <breadcrumb-template
      :headtitle="$route.meta.title"
      :breadcrumbcurrent="$route.meta.title"
    ></breadcrumb-template>
    <v-card class="card-outline force-remove-box">
      <v-card-text class="force-custom-bg">
        <v-container fluid>
          <!-- <v-row dense no-gutters class="mb-5 text-center text-md-left subtitle-1">
                        <v-col cols="12" lg="2">Total operators: <strong>{{ totaloperators }}</strong></v-col>
                        <v-col cols="12" lg="2">Total debit: <strong>{{ totalbalance }}</strong></v-col>
                        <v-col cols="12" lg="2">Total credit: <strong>{{ totalcredit }}</strong></v-col>
                        <v-col cols="12" lg="2">Total balance: <strong>{{ totaldebit }}</strong></v-col>
                    </v-row> -->
          <v-row dense class="d-flex justify-end mt-n2">
            <v-col cols="12" lg="2">
              <v-text-field
                dense
                class="regular-field"
                hide-details
                v-model="dt_filterDateFrom"
                label="Date"
                type="date"
              ></v-text-field>
            </v-col>

            <v-col cols="12" lg="2" class="mt-7" style="padding-top:5px;">
              <v-btn
                color="custom_info"
                class="float-right btn-block"
                @click="getDataFromApi()"
                >Search</v-btn
              >
            </v-col>

            <!-- <v-col cols="12" md="3" lg="3" xl="2">
                            <v-btn color="info" class="float-right btn-block" @click="modalForm">Add area</v-btn>
                        </v-col> -->

            <v-col cols="12" class="mt-2">
              <v-data-table
                class="custom-header-color table-bordered table-striped"
                :headers="dt_headers"
                :items="dt_resultlist"
                item-key="id"
                :loading="dt_loading"
                :options.sync="dt_options"
                :server-items-length="dt_totalResult"
              >
                <template v-slot:[`item.beginning`]="{ item }"
                  ><v-avatar :size="$gold_coin_sm">
                    <img :src="$goldCoinWhite" alt="coin"
                  /></v-avatar>
                  {{ item.beginning | toNumberWithDecimal }}
                </template>
                <template v-slot:[`item.debit`]="{ item }"
                  ><v-avatar :size="$gold_coin_sm">
                    <img :src="$goldCoinWhite" alt="coin"
                  /></v-avatar>
                  {{ item.debit | toNumberWithDecimal }}
                </template>
                <template v-slot:[`item.credit`]="{ item }"
                  ><v-avatar :size="$gold_coin_sm">
                    <img :src="$goldCoinWhite" alt="coin"
                  /></v-avatar>
                  {{ item.credit | toNumberWithDecimal }}
                </template>
                <template v-slot:[`item.balance`]="{ item }"
                  ><v-avatar :size="$gold_coin_sm">
                    <img :src="$goldCoinWhite" alt="coin"
                  /></v-avatar>
                  {{ item.balance | toNumberWithDecimal }}
                </template>

                <template
                  v-slot:[`item.actions`]="{ item }"
                  v-if="$role.restricAccess($route.name, 'edit')"
                >
                  <v-btn color="info" block dark small @click="findData(item)">
                    Edit
                  </v-btn>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
export default {
  data() {
    return {
      dt_headers: [
        {
          text: "ID",
          value: "id",
          name: "id",
          sortable: true,
          searchable: false,
          align: " d-none",
        },
        {
          text: "Operator",
          value: "username",
          name: "username",
          sortable: false,
          searchable: false,
        },
        {
          text: "Balance forwarded",
          value: "beginning",
          name: "beginning",
          sortable: false,
          searchable: false,
        },
        {
          text: "Debit",
          value: "debit",
          name: "debit",
          sortable: false,
          searchable: false,
        },
        {
          text: "Credit",
          value: "credit",
          name: "credit",
          sortable: false,
          searchable: false,
        },
        {
          text: "Ending balance",
          value: "balance",
          name: "balance",
          sortable: false,
          searchable: false,
        },
        // { text: 'Date', value: 'address', name: 'address', sortable: false, searchable: false},
      ],
      dt_options: {},
      dt_columns: {},
      dt_totalResult: 0,
      dt_filterDateFrom: this.$moment().format("YYYY-MM-DD"),
      dt_searchQuery: "",
      dt_resultlist: [],
      dt_loading: true,
      dt_itemsPerPage: 50,
      dt_reload: "",

      totaloperators: 0,
      totalbalance: 0,
      totalcredit: 0,
      totaldebit: 0,
    };
  },
  methods: {
    paramsfilter() {
      return {
        ...this.dt_options,
        query: this.dt_searchQuery,
        filterDateFrom: this.dt_filterDateFrom,
      };
    },
    async getDataFromApi() {
      this.dt_loading = true;
      var paramsfilter = await this.paramsfilter();
      this.dt_columns = await this.$YajraDT.setHeader(this.dt_headers);
      let params = await this.$YajraDT.params(
        paramsfilter,
        this.dt_options,
        this.dt_itemsPerPage,
        this.dt_columns
      );
      let apiPath = (await this.$_CONFIG.api()) + "/agentledger";

      await this.$axios
        .post(apiPath + "?" + this.$.param(params))
        .then((res) => {
          if (this.dt_totalResult != res.data.recordsFiltered) {
            this.dt_options.page = 1;
          }

          this.dt_resultlist = res.data.data;
          this.dt_totalResult = res.data.recordsFiltered;

          this.totaloperators = res.data.totaloperators;
          this.totalbalance = res.data.totalbalance;
          this.totalcredit = res.data.totalcredit;
          this.totaldebit = res.data.totaldebit;

          this.dt_loading = false;
        })
        .catch((err) => {
          this.dt_loading = false;
          console.log(err);
        });

      var unwatch = this.$watch(
        "dt_options.page",
        function(newValue, oldValue) {
          this.getDataFromApi();
          unwatch();
        },
        { deep: true }
      );
    },
  },
  created() {
    this.getDataFromApi();
  },
  mounted() {},
};
</script>
<style scoped></style>